import React from "react";

import {
  AiOutlineUsergroupDelete,
  AiOutlineDashboard,
  AiTwotoneSound,
  AiTwotoneTag,
  AiOutlineBold,
  AiOutlineUser,
  AiOutlineContacts,
  AiOutlineComment,
  AiTwotoneFolderOpen,
} from "react-icons/ai";
import { VscFeedback } from "react-icons/vsc";

import { SiCoursera } from "react-icons/si";

import {
  RiNewspaperLine,
  RiHealthBookFill,
} from "react-icons/ri";
import {
  FaChalkboardTeacher,
  FaLanguage,
  FaShippingFast,
} from "react-icons/fa";

import {
  BsBookHalf,
  BsCurrencyExchange,
  BsCartCheckFill,
} from "react-icons/bs";
import { FaGraduationCap } from "react-icons/fa";
import {
  UserOutlined,
  FileSearchOutlined,
  EditOutlined,
  UserAddOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import {
  MdOutlineRateReview,
  MdOutlineScreenSearchDesktop,
} from "react-icons/md";
import { ImBooks } from "react-icons/im";
import { BiMoney, BiDetail } from "react-icons/bi";
import { GiTeacher } from "react-icons/gi";

const routesConfig = [
  {
    id: "app",
    title: "Admin",
    messageId: "sidebar.admin",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        messageId: "sidebar.admin.dashboard",
        type: "item",
        icon: <AiOutlineDashboard />,
        path: "/admin/dashboard",
        routeName: "DASHBOARD",
      },
      {
        id: "gallery",
        title: "Image Gallery",
        messageId: "sidebar.admin.gallery",
        type: "item",
        icon: <AiTwotoneFolderOpen />,
        path: "/admin/gallery",
        routeName: "GALLERY",
      }, // gallery
      {
        id: "product-training",
        title: "Product Training",
        messageId: "sidebar.admin.product-training",
        type: "item",
        icon: <GiTeacher />,
        path: "/admin/product-training",
        routeName: "PRODUCT TRAINING",
      },
      {
        id: "users",
        title: "Admins",
        messageId: "sidebar.admin.users",
        type: "item",
        icon: <AiOutlineUsergroupDelete />,
        path: "/admin/users",
        routeName: "ADMINS",
      }, // admins
      {
        id: "ad-management",
        title: "Ad Management",
        messageId: "sidebar.admin.adManagement",
        type: "item",
        icon: <AiTwotoneSound />,
        path: "/admin/ad-management",
        routeName: "AD MANAGEMENT",
      }, // adManagement
      {
        id: "books",
        title: "Books",
        messageId: "sidebar.admin.books",
        type: "item",
        icon: <BsBookHalf />,
        path: "/admin/books",
        routeName: "BOOKS",
      }, // books
      {
        id: "blogs",
        title: "Blog Management",
        messageId: "sidebar.admin.blogs",
        type: "item",
        icon: <AiOutlineBold />,
        path: "/admin/blogs",
        routeName: "BLOGS",
      },
      {
        id: "books-category",
        title: "Book Categories",
        messageId: "sidebar.admin.booksCategory",
        type: "item",
        icon: <ImBooks />,
        path: "/admin/books-category",
        routeName: "BOOKS CATEGORY",
      }, // booksCategory
      {
        id: "contact-us",
        title: "Contact Us",
        messageId: "sidebar.admin.contact-us",
        type: "item",
        icon: <AiOutlineContacts />,
        path: "/admin/contact-us",
        routeName: "CONTACT US",
      }, // contact-us
      {
        id: "work-with-us",
        title: "Work With US",
        messageId: "sidebar.admin.work-with-us",
        type: "item",
        icon: <AiOutlineComment />,
        path: "/admin/work-with-us",
        routeName: "WORK WITH US",
      },
      {
        id: "coupons",
        title: "Coupon Management",
        messageId: "sidebar.admin.coupons",
        type: "item",
        icon: <AiTwotoneTag />,
        path: "/admin/coupons",
        routeName: "COUPONS",
      }, // coupons
      {
        id: "course-categories",
        title: "Course Categories",
        messageId: "sidebar.admin.courseCategories",
        type: "item",
        icon: <SiCoursera />,
        path: "/admin/course-categories",
        routeName: "COURSE CATEGORIES",
      }, // courseCategories
      {
        id: "products",
        title: "Courses",
        messageId: "sidebar.admin.products",
        type: "item",
        icon: <FaGraduationCap />,
        path: "/admin/products",
        routeName: "PRODUCTS",
      }, // products
      {
        id: "educational-hygienist",
        title: "Educational Hygienist",
        messageId: "sidebar.admin.educational-hygienist",
        type: "item",
        icon: <RiHealthBookFill />,
        path: "/admin/educational-hygienist",
        routeName: "EDUCATIONAL HYGIENIST",
      }, // educational-hygienist
      {
        id: "exchange-rate",
        title: "Exchange Rate",
        messageId: "sidebar.admin.exchangeRate",
        type: "item",
        icon: <BsCurrencyExchange />,
        path: "/admin/exchange-rate",
        routeName: "EXCHANGE RATE",
      }, // exchangeRate
      {
        id: "home-page-testimonial",
        title: "Home Page Testimonial",
        messageId: "sidebar.admin.home-testimonial",
        type: "item",
        icon: <MdOutlineRateReview />,
        path: "/admin/home-page-testimonial",
        routeName: "HOME TESTIMONIAL",
      }, // home-testimonial
      {
        id: "tutors",
        title: "Instructors",
        messageId: "sidebar.admin.tutors",
        type: "item",
        icon: <FaChalkboardTeacher />,
        path: "/admin/tutors",
        routeName: "TUTORS",
      }, // instructors
      {
        id: "languages",
        title: "Languages",
        messageId: "sidebar.admin.languages",
        type: "item",
        icon: <FaLanguage />,
        path: "/admin/languages",
        routeName: "LANGUAGE",
      }, // languages
      
      {
        id: "orders",
        title: "Orders",
        messageId: "sidebar.admin.order",
        type: "item",
        icon: <BsCartCheckFill />,
        path: "/admin/orders",
        routeName: "ORDER",
      }, // order
      {
        id: "outsourceauthor",
        title: "OutSource Auhtor",
        messageId: "sidebar.admin.outsourceauthor",
        type: "item",
        icon: <UserAddOutlined />,
        path: "/admin/outsourceauthor",
        routeName: "OUTSOURCEAUTHOR",
      }, // outsourceauthor
      {
        id: "professional-profile",
        title: "Professional Profile",
        messageId: "sidebar.admin.professional-profile",
        type: "item",
        icon: <UserOutlined />,
        path: "/admin/professional-profile",
        routeName: "PROFESSIONAL PROFILE",
      }, // professional-profile
      {
        id: "quiz",
        title: "Quiz",
        messageId: "sidebar.admin.quiz",
        type: "item",
        icon: <ProfileOutlined />,
        path: "/admin/quiz",
        routeName: "QUIZ",
      }, // quiz
      {
        id: "reports",
        title: "Reports",
        messageId: "sidebar.admin.reports",
        type: "item",
        icon: <BiDetail />,
        path: "/admin/reports",
        routeName: "REPORTS",
      }, // reports
      {
        id: "reviews",
        title: "Reviews",
        messageId: "sidebar.admin.rating",
        type: "item",
        icon: <VscFeedback />,
        path: "/admin/reviews",
        routeName: "REVIEWS",
      }, // reviews
      {
        id: "scientific-evidence",
        title: "Scientific Evidence",
        messageId: "sidebar.admin.scientific-evidence",
        type: "item",
        icon: <FileSearchOutlined />,
        path: "/admin/scientific-evidence",
        routeName: "SCIENTIFIC EVIDENCE",
      },
      {
        id: "shipping-zones",
        title: "Shipping Zones",
        messageId: "sidebar.admin.shipping-zones",
        type: "item",
        icon: <FaShippingFast />,
        path: "/admin/shipping-zones",
        routeName: "SHIPPING ZONES",
      }, // shipping-zones
      {
        id: "static-content",
        title: "Static Content",
        messageId: "sidebar.admin.static-content",
        type: "item",
        icon: <EditOutlined />,
        path: "/admin/static-content",
        routeName: "STATIC CONTENT",
      }, // static-content
      {
        id: "students",
        title: "Students",
        messageId: "sidebar.admin.students",
        type: "item",
        icon: <RiNewspaperLine />,
        path: "/admin/students",
        routeName: "STUDENTS",
      }, // students
      {
        id: "searchContext",
        title: "Search Context",
        messageId: "sidebar.admin.search-context",
        type: "item",
        icon: <MdOutlineScreenSearchDesktop />,
        path: "/admin/search-context",
        routeName: "SEARCH CONTEXT",
      }, // search context
      {
        id: "tax-management",
        title: "Tax Management",
        messageId: "sidebar.admin.tax-management",
        type: "item",
        icon: <BiMoney />,
        path: "/admin/tax-management",
        routeName: "TAX MANAGEMENT",
      }, // tax-management
      {
        id: "webex-auth",
        title: "Webex Auth",
        messageId: "sidebar.admin.webexAuth",
        type: "item",
        icon: <AiOutlineUser />,
        path: "/admin/webex-auth",
        routeName: "WEBEX AUTH",
      }, // webexAuth
    ].sort((a, b) => {
      let nameA = a.title.toLowerCase(); // Convert names to lowercase for case-insensitive sorting
      let nameB = b.title.toLowerCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    }),
  },
];
export default routesConfig;

// {
//   id: "live-courses",
//   title: "Live Courses",
//   messageId: "sidebar.admin.liveCourses",
//   type: "item",
//   icon: <BiChalkboard />,
//   path: "/admin/live-courses",
//   routeName: "LIVE_COURSES",
// },
// {
//   id: "product-types",
//   title: "Product Types",
//   messageId: "sidebar.admin.productTypes",
//   type: "item",
//   icon: <FiList />,
//   path: "/admin/product-types",
//   routeName: "PRODUCT TYPES",
// },
// {
//   id: "client-logo",
//   title: "Client Logo",
//   messageId: "sidebar.admin.client-logo",
//   type: "item",
//   icon: <BsFillPeopleFill />,
//   path: "/admin/client-logo",
//   routeName: "CLIENT LOGO",
// },
// {
//   id: "map",
//   title: "Google Map",
//   messageId: "sidebar.admin.map",
//   type: "item",
//   icon: <AiOutlineUser />,
//   path: "/admin/map",
//   routeName: "MAP",
// },
// {
//   id: "reviews",
//   title: "Reviews",
//   messageId: "sidebar.admin.rating",
//   type: "item",
//   icon: <MdReviews />,
//   path: "/admin/reviews",
//   routeName: "RATING",
// },
// {
//   id: "product-training",
//   title: "Product Training",
//   messageId: "sidebar.admin.product-training",
//   type: "item",
//   icon: <GiTeacher />,
//   path: "/admin/product-training",
//   routeName: "PRODUCT TRAINING",
// },
// {
//   id: "shipping-charge",
//   title: "Shipping Charges",
//   messageId: "sidebar.admin.shipping-charge",
//   type: "item",
//   icon: <FaShippingFast />,
//   path: "/admin/shipping-charge",
//   routeName: "SHIPPING CHARGES",
// },

// {
//   id: "tutorship",
//   title: "TutorShip",
//   messageId: "sidebar.admin.tutorship",
//   type: "item",
//   icon: <AiOutlineContacts />,
//   path: "/admin/tutorship",
//   routeName: "TUTORSHIP",
// },
// {
//   id: "community",
//   title: "Community",
//   messageId: "sidebar.admin.community",
//   type: "item",
//   icon: <AiOutlineContacts />,
//   path: "/admin/community",
//   routeName: "Community",
// },
